// Generated by purs version 0.13.0
"use strict";
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var addToRepository = function (chance) {
    return function (value) {
        return function (v) {
            return {
                total: v.total + chance | 0,
                options: Data_Array_NonEmpty.snoc(v.options)({
                    chance: chance,
                    value: value
                })
            };
        };
    };
};
module.exports = {
    addToRepository: addToRepository
};
